import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  TextInput,
  Keyboard
} from 'react-native'
import { Ionicons } from '@expo/vector-icons'

// components
import ModalPopup from '../shared/modal/ModalPopup'
import { colorPalette, globalStyles } from '../../static/styles/global'
import CustomButton from '../shared/button/Button'
//translation
import { useTranslation } from 'react-i18next'

interface AddNoteProps {
  title?: string
  visible: boolean
  setVisible: any
  note: string
  setNote: (note: string) => void
  savedNote: string
  setSavedNote: (note: string) => void
  handleSaveNote: (note: string) => void
  mode: 'add' | 'edit'
}

const AddNote = ({
  title,
  visible,
  setVisible,
  note,
  setNote,
  savedNote,
  setSavedNote,
  handleSaveNote,
  mode
}: AddNoteProps): JSX.Element => {
  const { t } = useTranslation()
  const handleDiscard = (): void => {
    setVisible(!visible)
  }

  const handleAddNote = (): void => {
    // TODO: call API to save note to database and display it on the screen
    setSavedNote(note)
    handleSaveNote(note)

    // clear form
    // setNote('')

    // dismiss the keyboad and fade-out the modal
    Keyboard.dismiss()
    setVisible(!visible)
  }

  const handlEditNote = (): void => {
    // TODO: call API to re-save note to database and display it on the screen
    setSavedNote(note)
    handleSaveNote(note)

    // clear form
    // setNote('')

    // dismiss the keyboad and fade-out the modal
    Keyboard.dismiss()
    setVisible(!visible)
  }

  return (
    <ModalPopup
      visible={visible}
      position="bottom"
      screen="full"
      flatBottom={false}
    >
      <View style={styles.modalHeader}>
        <Text
          style={[
            globalStyles.text,
            globalStyles.fs18,
            globalStyles.fwBold,
            globalStyles.blackTextColor
          ]}
        >
          {title}
        </Text>
        <TouchableOpacity onPress={() => setVisible(!visible)}>
          <Ionicons name="close-sharp" size={24} color={colorPalette.black} />
        </TouchableOpacity>
      </View>
      <View style={[styles.modalBody]}>
        <View style={[styles.modalBodyInner]}>
          <TextInput
            multiline
            numberOfLines={4}
            placeholder=""
            style={[
              globalStyles.input,
              globalStyles.inputLight,
              globalStyles.textarea,
              globalStyles.lightBgColor
            ]}
            blurOnSubmit={false}
            value={note}
            onChangeText={(text) => setNote(text)}
          />
          <View
            style={[
              globalStyles.hDirection,
              globalStyles.hBetweenItems,
              globalStyles.mt2,
              globalStyles.mb2
            ]}
          >
            <View style={[globalStyles.flexOne]}>
              <CustomButton
                text={t('discard')}
                onPress={handleDiscard}
                reverse={true}
                light={true}
              />
            </View>
            <View style={[globalStyles.flexOne]}>
              <CustomButton
                text={mode === 'add' ? t('addnote') : t('savenote')}
                onPress={mode === 'add' ? handleAddNote : handlEditNote}
                isDisabled={!note}
                color={'secondary'}
              />
            </View>
          </View>
        </View>
      </View>
    </ModalPopup>
  )
}

const styles = StyleSheet.create({
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderColor: colorPalette.darkLight
  },
  modalBody: {
    paddingVertical: 0,
    paddingHorizontal: 0
  },
  modalBodyInner: {
    padding: 16
  },
  dayCol: {
    minWidth: 90
  }
})

export default AddNote
